import { render, staticRenderFns } from "./PurchaseTrainingConfirmationModal.vue?vue&type=template&id=84a7db4a&"
import script from "./PurchaseTrainingConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./PurchaseTrainingConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports